import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Footer from "../../components/layout/Footer";
import EpisodeList from "../../components/movie/EpisodeList";
import HeaderPost from "../../components/movie/HeaderPost";
import InfoMovie from "../../components/movie/InfoMovie";
import ListCount from "../../components/movie/ListCount";
import OptionMovie from "../../components/movie/OptionMovie";
import VideoPlayer from "../../components/movie/VideoPlayer";
import Header from "../../components/ui/Header";
import { useEpisodes } from "../../hooks/useEpisodes";
import { usePostDetails } from "../../hooks/usePost";
import { postApi } from "../../services/api/postApi";
import { ButtonNavigationInterface } from "../../types/dashboard.type";
import NotFound from "../NotFound";
import RelatedPosts from "../../components/ui/RelatedPosts";

const MovieDetails: React.FC<{ extraData?: any }> = ({ extraData }) => {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  // Ưu tiên lấy từ props, sau đó mới lấy từ location.state
  const [movie, setMovie] = useState(extraData || location.state?.item || null);
  const { data: fetchedMovie } = usePostDetails(slug || "", "movie");
  const [descExpanded, setDescExpanded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const { episodes: rawEpisodes, isLoading } = useEpisodes(
    "movie",
    location.state?.item?.id || "",
    slug || ""

  );
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");
  const navigation = useNavigate();
  const { lang } = useParams<{ lang: string }>(); // Retrieve lang from URL
  const handleClick = (button: ButtonNavigationInterface) => {
    const path = `/${lang}/list`; // Include lang in the path
    navigation(path, { state: button }); // Pass item in state
  };
  // Scroll to top when component mounts or slug changes
  useEffect(() => {
    window.scrollTo(0, 0);
    // Reset states when slug changes
    setDescExpanded(false);
    setIsPlaying(false);
    setCurrentVideoUrl("");
  }, [slug]);

  // Ensure video stops playing when navigating away (component unmounts)
  useEffect(() => {
    return () => {
      // Cleanup when component unmounts (navigating away)
      setIsPlaying(false);
      setCurrentVideoUrl("");
    };
  }, []);

  const handlePlayEpisode = (episodeUrl?: string) => {
    setIsPlaying(true);
    setCurrentVideoUrl(episodeUrl || "");
  };
  useEffect(() => {
    if (fetchedMovie) {
      setMovie(fetchedMovie);

      // Track view after fetching movie details
      if (fetchedMovie.id) {
        postApi
          .trackPostView("movie", fetchedMovie.id)
          .then(() => console.log("View tracked successfully"))
          .catch((err) => console.error("Error tracking view:", err));
      }
    }
  }, [fetchedMovie]);

  // Separate effect to handle episodes
  useEffect(() => {
    if (rawEpisodes.length > 0 && !currentVideoUrl) {
      setCurrentVideoUrl(rawEpisodes[0].source[0]?.link || "");
    }
  }, [rawEpisodes, currentVideoUrl]);

  if (!movie) {
    return (
      <div className="movie-details bg-mainBlack">
       <NotFound />
        <div className="flex flex-col items-center justify-center min-h-screen">
          
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="movie-details bg-mainBlack text-white min-h-screen w-full">
      <Header isBack/>
      {!isPlaying ? (
        <HeaderPost
          title={movie?.title || ""}
          banner={movie.banner}
          playUrl={currentVideoUrl}
          type="movie"
          loading={isLoading}
          onPlay={handlePlayEpisode} // Pass the onPlay prop
          description={movie.description}
        />
      ) : (
        <VideoPlayer
          episodes={rawEpisodes || []} // Pass episodes to VideoPlayer
          videoUrl={currentVideoUrl}
          onPlayEpisode={handlePlayEpisode} // Pass the onPlayEpisode prop
        />
      )}
      <ListCount
        episodeTotal={rawEpisodes?.length || 0}
        likeCount={movie.like_count}
        ratingAvg={movie.rating_avg}
      />
      {!isPlaying && (
        <EpisodeList
          currentVideoUrl={currentVideoUrl} // Pass the current
          episodes={rawEpisodes || []} // Updated to pass episodes directly
          movieSlug={movie.slug}
          onPlayEpisode={handlePlayEpisode} // Pass the onPlayEpisode prop
        />
      )}
      <OptionMovie
        episodeTotal={movie.episode_total}
        likeCount={movie.like_count}
        ratingAvg={movie.rating_avg}
        onPlay={() => setIsPlaying(true)}
        isPlaying={isPlaying}
        post={movie}
      />
      <InfoMovie
        releaseYear={movie.release_year || []}
        categories={movie.categories || []}
        directors={movie.directors || []}
        actors={movie.actors || []}
        description={movie.description || ""}
        descExpanded={descExpanded}
        setDescExpanded={setDescExpanded}
      />

      <RelatedPosts
        postId={movie.id}
        postType="movie"
        title={movie.related_post?.label || "Phim liên quan"}
      />
      <Footer />
    </div>
  );
};

export default MovieDetails;
